function fitProductTitle() {
  const titleContainer = document.querySelector('.product__title');
  if (!titleContainer) return;

  const title = titleContainer.querySelector('h1');
  if (!title) return;

  // Largeur du conteneur. Si la mise en page n'est pas prête (0px), on abandonne
  // ce passage : le ResizeObserver / resize / pageshow relanceront le fit dès
  // que la largeur réelle sera connue (évite un titre rétréci à 10px).
  const containerWidth = titleContainer.offsetWidth;
  if (containerWidth <= 0) return;

  // Start with a large font size. Jusqu'à 989 px, le titre remplit la largeur de
  // l'écran comme sur téléphone : 200 px ne suffiraient plus vers 820 px.
  let fontSize = window.innerWidth < 990 ? Math.max(200, Math.ceil(containerWidth * 0.6)) : 200;
  title.style.fontSize = fontSize + 'px';
  title.style.whiteSpace = 'nowrap';
  title.style.lineHeight = '0.9';

  // Reduce font size until it fits
  while (title.scrollWidth > containerWidth && fontSize > 10) {
    fontSize -= 1;
    title.style.fontSize = fontSize + 'px';
  }
}

function revealProductTitle() {
  const titleContainer = document.querySelector('.product__title');
  const title = titleContainer && titleContainer.querySelector('h1');
  if (title) title.style.visibility = 'visible';
}

function fitAndRevealProductTitle() {
  fitProductTitle();
  revealProductTitle();
}

// Observe la LARGEUR du conteneur du titre et re-fit à chaque changement.
// C'est ce qui rend le dimensionnement fiable au-delà du premier chargement :
// - product-scroll-behavior.js reconstruit le DOM et déplace .product__title
//   (la largeur du conteneur change → on re-fit) ;
// - retour via bfcache (bouton précédent) où load/DOMContentLoaded ne refirent
//   pas → le moindre ajustement de layout déclenche un re-fit ;
// - redimensionnement de la fenêtre.
// Pas de boucle de rétroaction : .product__title est en width:100% (sa largeur
// ne dépend pas du font-size du <h1> qu'on modifie).
let titleResizeObserver = null;
function observeProductTitle() {
  if (!('ResizeObserver' in window)) return;
  const titleContainer = document.querySelector('.product__title');
  if (!titleContainer) return;
  if (titleResizeObserver) titleResizeObserver.disconnect();
  // On re-fit seulement (pas de reveal ici) pour éviter un flash de
  // re-dimensionnement ; la révélation reste gérée par load / fonts.ready /
  // pageshow / product-info:loaded (au bon moment, taille correcte).
  titleResizeObserver = new ResizeObserver(function () {
    fitProductTitle();
  });
  titleResizeObserver.observe(titleContainer);
}

// Fit as soon as the DOM is ready (still hidden via CSS, reserves layout space).
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    fitProductTitle();
    observeProductTitle();
  });
} else {
  fitProductTitle();
  observeProductTitle();
}

// Re-fit once the real font (Inter) is loaded — its metrics differ from the
// fallback font used before, which is what made the title mis-sized.
// C'est LA cause du bug "au 1er accès le titre déborde à droite, OK après
// Ctrl+R" : à froid la police de titre n'est pas en cache, le titre est
// mesuré avec la police de repli (plus étroite) puis déborde quand la vraie
// police (plus large) s'applique. Le ResizeObserver ne le capte pas car la
// largeur du CONTENEUR (width:100%) ne change pas au swap de police.
if (document.fonts && document.fonts.ready) {
  document.fonts.ready.then(fitAndRevealProductTitle);
  // loadingdone se déclenche à CHAQUE fin de chargement de police (y compris
  // la police de titre appliquée après coup) : on re-fit à chaque fois.
  if (document.fonts.addEventListener) {
    document.fonts.addEventListener('loadingdone', fitAndRevealProductTitle);
  }
}

// Filet de sécurité : quelques re-fits différés après le chargement pour
// absorber toute application tardive de police / stabilisation de layout
// (indépendant de la famille de police).
function scheduleSettleRefits() {
  [150, 400, 900].forEach(function (delay) {
    setTimeout(fitAndRevealProductTitle, delay);
  });
}
if (document.readyState === 'complete') {
  scheduleSettleRefits();
} else {
  window.addEventListener('load', scheduleSettleRefits);
}

// Swap produit sans rechargement (combined listings / product-swap) : le bloc
// product-info est remplacé et émet 'product-info:loaded'. On re-fit + révèle
// + ré-observe (l'ancien conteneur est détaché).
document.addEventListener('product-info:loaded', function () {
  fitAndRevealProductTitle();
  observeProductTitle();
});

// Final fit + reveal once everything (layout, images, entrance animation,
// product-scroll-behavior rebuild) has settled. Revealing only here avoids the
// visible resize steps.
if (document.readyState === 'complete') {
  fitAndRevealProductTitle();
} else {
  window.addEventListener('load', fitAndRevealProductTitle);
}

// Retour via bfcache (précédent/suivant) : load/DOMContentLoaded/fonts.ready ne
// se redéclenchent pas. On re-fit, on révèle, et on ré-attache l'observer (le
// conteneur peut avoir été reconstruit entre-temps).
window.addEventListener('pageshow', function (event) {
  if (event.persisted) {
    fitAndRevealProductTitle();
    observeProductTitle();
  }
});

// Safety: never leave the title hidden.
setTimeout(revealProductTitle, 3000);

// Re-run on window resize. Seulement si la largeur change : sur iPhone, la barre du
// navigateur change la hauteur de la fenêtre à chaque changement de sens de défilement.
let resizeTimeout;
let lastResizeWidth = window.innerWidth;
window.addEventListener('resize', function () {
  if (window.innerWidth === lastResizeWidth) return;
  lastResizeWidth = window.innerWidth;
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(fitProductTitle, 100);
});

// Re-run on section reload (éditeur de thème / rechargement de section)
document.addEventListener('shopify:section:load', function () {
  fitAndRevealProductTitle();
  observeProductTitle();
});
